import React, { useEffect, useState } from "react";
import { Box } from "orcs-design-system";
import { withRouter } from "react-router";
import { useMutation } from "@apollo/client/react";
import { get } from "lodash";

import { useAuth0 } from "src/contexts/auth0Provider";
import WorkspaceForm from "../../components/Workspaces/Form";

import { createWorkspace as createWorkspaceMutation } from "./workspace.graphql";

const getCreateWorkspaceErrorMessage = (error) => {
  const graphqlMessage =
    get(error, "graphQLErrors[0].message") || error?.message;

  if (!graphqlMessage) {
    return "Unable to create workspace. Please try again.";
  }

  if (graphqlMessage.includes("description must NOT have fewer than 1")) {
    return "Description is required.";
  }

  if (graphqlMessage.includes("name must NOT have fewer than 1")) {
    return "Name is required.";
  }

  if (graphqlMessage.includes("name must NOT have more than 512")) {
    return "Name must be 512 characters or fewer.";
  }

  if (graphqlMessage.includes("description must NOT have more than 2048")) {
    return "Description must be 2048 characters or fewer.";
  }

  return graphqlMessage;
};

const CreateWorkspacePage = () => {
  const { user } = useAuth0();

  const onCreateWorkspaceCompleted = (data) => {
    window.location.href = `https://${window.location.hostname}:${window.location.port}/${data.workspace.id}/teams`;
  };

  const [createWorkspace, { error, loading }] = useMutation(
    createWorkspaceMutation,
    {
      onCompleted: (data) => onCreateWorkspaceCompleted(data),
    }
  );
  const [submitErrorMessage, setSubmitErrorMessage] = useState();

  useEffect(() => {
    if (error) {
      setSubmitErrorMessage(getCreateWorkspaceErrorMessage(error));
    }
  }, [error]);

  const clearSubmitError = () => {
    setSubmitErrorMessage(undefined);
  };

  const onCreateWorkspace = ({ name, description, configType }) => {
    clearSubmitError();
    createWorkspace({
      variables: {
        input: {
          name,
          description,
          configType: get(configType, "value"),
        },
      },
    });
  };

  const { family_name: familyName, given_name: givenName, nickname } = user;
  const username =
    familyName && givenName ? `${givenName} ${familyName}` : nickname;

  return (
    <Box p="r">
      <WorkspaceForm
        preferredUsername={username}
        onSubmit={onCreateWorkspace}
        isLoading={loading}
        submitError={submitErrorMessage}
        onClearSubmitError={clearSubmitError}
      />
    </Box>
  );
};

export { getCreateWorkspaceErrorMessage };

export default withRouter(CreateWorkspacePage);
